module.exports = __webpack_public_path__ + "static/media/warehouse-image.8fa01c40.jpeg";